// The template's own destructive action (template-page spec §3). The server
// refuses to delete a template surveys still use (a constraint violation),
// so that is said up front instead of offering a button that would fail; the
// refusal stays as the net for a survey taking the template after load. The rule and
// the confirmation are shared with the list's row menu
// (delete-template-dialog.tsx).

import { useState } from "react";
import type { Template } from "@/api/types";
import { DangerZoneSection } from "@/components/section-page/danger-zone";
import { DeleteTemplateDialog, deleteRefusal } from "./delete-template-dialog";
import { TEMPLATE_SECTION } from "./template-sections";

export function TemplateDangerZone({ template, onDeleted }: { template: Template; onDeleted: () => void }) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <DangerZoneSection
                id={TEMPLATE_SECTION.danger}
                description="Deletes the template. This can't be undone."
                action="Delete template"
                disabledReason={deleteRefusal(template.surveyCount)}
                onAction={() => setOpen(true)}
            />
            <DeleteTemplateDialog template={template} open={open} onOpenChange={setOpen} onDeleted={onDeleted} />
        </>
    );
}
